import React from "react";
import TableShimmer from "../../../components/table/TableShimmer";
import EmptyTableMessage from "../../../components/table/EmptyTableMessage";
import { formatMoney } from "../../../helper/formatter";

const TablaDetalle = ({ detalle, actionRow, loading = false }) => {
    return (
        <div className="table-responsive">
            <table
                className={
                    "table table-bordered widget-table align-middle rounded table-sm " +
                    (!loading && " table-hover table-striped")
                }>
                <thead>
                    <tr className="text-nowrap">
                        <th>CANTIDAD</th>
                        <th width="40%">DESCRIPCION</th>
                        <th>PRECIO UNITARIO</th>
                        <th>VENTAS EXCENTAS</th>
                        <th>VENTAS NO SUJETAS</th>
                        <th>VENTAS SUJETAS</th>
                        {actionRow ? <th width="10%"></th> : null}
                    </tr>
                </thead>
                <tbody>
                    {!loading ? (
                        detalle?.length > 0 ? (
                            detalle?.map((item, i) => (
                                <tr key={i} onDoubleClick={() => actionRow("update", i)}>
                                    <td>
                                        {item.cantidad != "" && item.cantidad != null
                                            ? formatMoney(item.cantidad, "0,0.[00000]")
                                            : ""}
                                    </td>
                                    <td className="fw-bold text-gray-600">{item.descripcion}</td>
                                    <td className="text-nowrap">
                                        <b className="text-dark ">
                                            {item.precio_unitario ? formatMoney(item.precio_unitario, "$ 0,0.00[000]") : ""}
                                        </b>
                                    </td>
                                    <td className="text-nowrap">
                                        {item.tipoVentaId == 3 && item.venta != ""
                                            ? formatMoney(item.venta, "$ 0,0.00[000]")
                                            : ""}
                                    </td>
                                    <td className="text-nowrap">
                                        {item.tipoVentaId == 2 && item.venta != ""
                                            ? formatMoney(item.venta, "$ 0,0.00[000]")
                                            : ""}
                                    </td>
                                    <td className="text-nowrap">
                                        {item.tipoVentaId == 1 && item.venta != "" ? formatMoney(item.venta) : ""}
                                    </td>
                                    {actionRow ? (
                                        <td className="text-nowrap">
                                            <button
                                                className={"btn btn-xs w-40px btn-primary"}
                                                onClick={() => actionRow("update", i)}>
                                                <i className="fa fa-edit"></i>
                                            </button>
                                            <button
                                                className={"btn btn-xs w-40px btn-danger ms-1"}
                                                onClick={() => actionRow("remove", i)}>
                                                <i className="fa fa-times"></i>
                                            </button>
                                        </td>
                                    ) : null}
                                </tr>
                            ))
                        ) : (
                            <EmptyTableMessage columns={7} />
                        )
                    ) : (
                        <TableShimmer columns={7} enableAnimation />
                    )}
                </tbody>
            </table>
        </div>
    );
};

export default TablaDetalle;
